/* =========================================================
   ÉLAN MARAIS — Klaviyo Wishlist Digest Bridge (clean)
   - Luistert naar jouw eigen event: em:wishlist:changed
   - Cross-tab: storage event
   - Roept EM_WISHLIST_DIGEST.onChange() aan (als die bestaat)
   ========================================================= */
(function () {
  "use strict";

  var STORAGE_KEY = "em_wishlist_v1";

  function pingDigest(reason) {
    try {
      if (window.EM_WISHLIST_DIGEST && typeof window.EM_WISHLIST_DIGEST.onChange === "function") {
        window.EM_WISHLIST_DIGEST.onChange(reason || "bridge");
      }
    } catch (e) {}
  }

  // 1) Same-tab: jouw wishlist engine dispatcht dit event al
  window.addEventListener("em:wishlist:changed", function () {
    pingDigest("wishlist_changed_event");
  });

  // 2) Cross-tab updates
  window.addEventListener("storage", function (e) {
    if (e && e.key === STORAGE_KEY) pingDigest("storage_event");
  });

  // 3) On load: als wishlist al gevuld is → arm digest
  document.addEventListener("DOMContentLoaded", function () {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : [];
      var items = Array.isArray(data) ? data : (data && Array.isArray(data.items) ? data.items : []);
      if (items && items.length) pingDigest("dom_ready_has_items");
    } catch (e) {}
  });
})();

